export default __webpack_public_path__ + "static/media/clio-gallery-9.0a2f29c2.jpg";